import { render, staticRenderFns } from "./BaseLeftMenu.vue?vue&type=template&id=a2f28f3a&scoped=true&"
import script from "./BaseLeftMenu.vue?vue&type=script&lang=js&"
export * from "./BaseLeftMenu.vue?vue&type=script&lang=js&"
import style0 from "./BaseLeftMenu.vue?vue&type=style&index=0&id=a2f28f3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f28f3a",
  null
  
)

export default component.exports